<template>
    <div id="fileupload">
        <label class="btn btn-white">
            <i class="fa fa-paperclip"
                ><input
                    type="file"
                    @change="upload"
                    style="display: none"
                    accept="image/*"
            /></i>
        </label>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import { applyOssCredentials } from "@/modules/global/services/oss";
import uniqid from "uniqid";

export default {
    name: "fileupload",

    methods: {
        upload: async function (e) {
            var file = e.target.files[0];
            if (!file) return;
            if (file.type.indexOf("image") == -1) return;

            try {
                await applyOssCredentials(AWS);
            } catch (error) {
                this.$store.commit("showAlert", {
                    message: `Terjadi kesalahan pada upload!`,
                    submessage: error.message,
                    type: "error",
                });
                return;
            }

            var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT;
            var bucket = new AWS.S3({
                endpoint: spaceEndpoint,
            });

            var fileExt = file.name.substr(-4);
            var filename = uniqid() + fileExt;
            var params = {
                Bucket: process.env.VUE_APP_OSS_BUCKET,
                Key: "gallery/" + this.context + "/" + filename,
                Body: file,
                ContentType: file.type,
                ACL: "public-read",
            };

            var context = this;
            bucket.upload(params, function (error, data) {
                if (!error) {
                    context.$emit("uploaded", data.Location);
                }
            });
        },
    },

    props: ["accept", "context"],
};
</script>



// WEBPACK FOOTER //
// FileUpload.vue?a0edbcc6